import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import "./mobile-search-input.scss"
import { searchUrl } from '@src/app/routes';
import SearchIcon from "@src/componentsNew/Icons/Icons/SearchIcon";
import CloseIcon from "@src/componentsNew/Icons/Icons/CloseIcon";

interface IProps {
  isSearchPage: boolean;
  formActionUrl?: string;
  searchValue?: string;
  onFocus?: any;
  onChange?: any;
  onSubmit?: any;
  onClearValue?: any;
}

const MobileSearchInput = ({
  isSearchPage,
  searchValue,
  onFocus,
  onChange,
  onSubmit,
  onClearValue }: IProps) => {
  const history = useHistory();
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && isSearchPage) {
      inputRef.current.focus();
    }
  }, []);

  const onClickHandler = () => {
    if (!isSearchPage) {
      inputRef.current.blur();
      history.push(searchUrl);
    }
  };

  return (
    <form id="search-form" onSubmit={onSubmit}>
      <SearchIcon cName='search-icon' width='20' height='20' />
      <input
        className="search-input"
        type="search"
        name="q"
        placeholder="Find your own flavor"
        autoComplete={"off"}
        ref={inputRef}
        value={searchValue}
        onFocus={onFocus}
        onClick={onClickHandler}
        onChange={onChange}
      />
      {
        searchValue?.length ?
          <CloseIcon cName="clear-btn" onClick={onClearValue} />
          : null
      }
    </form>
  );
};

export default MobileSearchInput;
